module.exports = __webpack_public_path__ + "img/next-circle.76d53974.svg";